// Feature Gates
export const SHOW_IMPACT_REPORT_GATE = 'Show_2026_Impact_Report_User_Profile';
export const SHOW_GIVING_HISTORY_DOWNLOAD_GATE = 'Show_2026_Giving_History_Download_User_Profile';
